export default {
  "integration": {
    "title": "Integrations",
    "add_integration": "Add integration",
    "delete": "Delete"
  }
};
